import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Avatar } from "../../components/ui/Avatar";
import { formatRelative } from "../reports/relativeTime";

import type { ActivityEvent, ActivityEventType } from "./api";

export function FeedItem({
  event,
  onReportIssue,
}: {
  event: ActivityEvent;
  onReportIssue?: () => void;
}) {
  const { t } = useTranslation();
  const actor = event.user_id ? event.user_id.slice(0, 6) : t("community.actor_anonymous");
  return (
    <li className="flex items-start gap-3 rounded-lg border border-line bg-surface p-3">
      <Avatar userId={event.user_id} label={null} size={36} />
      <div className="min-w-0 flex-1">
        <p className="text-sm text-fg">
          <span className="font-medium">{actor}</span>
          <span className="text-fg-mute"> · {event.summary} </span>
          <Link to={`/stations/${event.station_id}`} className="text-fg-mute hover:text-fg">
            {event.station_name}
          </Link>
        </p>
        <p className="num mt-0.5 text-xs text-fg-faint">{formatRelative(event.created_at)}</p>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-1">
        <EventGlyph type={event.event_type} />
        {onReportIssue && (
          <button
            type="button"
            onClick={onReportIssue}
            className="text-[10px] text-fg-faint hover:text-amber"
          >
            {t("community.action_report_issue")}
          </button>
        )}
      </div>
    </li>
  );
}

function EventGlyph({ type }: { type: ActivityEventType }) {
  const glyph = type === "report" ? "📋" : type === "check_in" ? "🔌" : "⚠️";
  return (
    <span aria-hidden className="text-fg-mute">
      {glyph}
    </span>
  );
}
